import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from "react-router-dom";

import ProtectedRoute from './components/ProtectedRoute.jsx';
import { DarkModeProvider } from './components/DarkModeContext.jsx';
import { DeviceLayoutProvider } from './components/DeviceLayoutProvider.jsx';

import Home from './pages/Generali/Home.js';
import Login from './pages/Generali/Login.jsx';
import Crea from './pages/Generali/Crea.jsx';
import Attiva from './pages/Generali/Attiva.jsx';

import DashDev from './pages/Dev/Dash.jsx';
import ImpostazioniDev from './pages/Dev/Impostazioni.jsx';

import DashManager from './pages/Manager/Dash.jsx';
import LogManager from './pages/Manager/Log.jsx';
import ImpostazioniManager from './pages/Manager/Impostazioni.jsx';
// import Licenza from './pages/Manager/Licenza.js';
import AziendeManager from './pages/Manager/Clienti.jsx';
import UtentiManager from './pages/Manager/Utenti.jsx';
import CategorieStatiManager from './pages/Manager/CategorieStati.jsx';
import AnagraficaManager from './pages/Manager/Anagrafica.jsx';
import CodiciManager from './pages/Manager/Codici.jsx';
import ReportManager from './pages/Manager/Report.jsx';

import DashUtente from './pages/Utente/Dash.jsx';
import ClienteUtente from './pages/Utente/Cliente.jsx';
// import CreaComponenteUtente from './pages/Utente/CreaComponenteUtente.js';
// import ProfiloUtente from './pages/Utente/ProfiloUtente.js';
import ScanUtente from './pages/Utente/Articolo.jsx';
// import FotoUtente from './pages/Utente/FotoUtente.js';

import DashVenditore from './pages/Venditore/Dash.jsx';
import CodiciVenditore from './pages/Venditore/Codici.jsx';

function App() {

    // useEffect(() => {
    //     if (window.Worker) {
    //         console.log("1");
    //         Notification.requestPermission().then(permission => {
    //             console.log("2");
    //             if (permission === "granted") {
    //                 const wrk = new Worker(`/Worker.js`);
    //                 wrk.postMessage('start');


    //                 wrk.onmessage = (event) => {
    //                     const { status, data, error } = event.data;

    //                     if (status === 'success') {
    //                         // console.log(data);
    //                         sendNotification(data);
    //                     }
    //                     else {
    //                         console.error('Error fetching data from the worker', error);
    //                     }
    //                 };
    //             } else {
    //                 console.log("Notifiche non permesse");
    //             }
    //         });
    //     }
    // }, []);

    // const sendNotification = async (data) => {
    //     try {
    //         if (Notification.permission === "granted") {
    //             new Notification("Titolo", { body: data });
    //         } else if (Notification.permission !== "denied") {
    //             Notification.requestPermission().then((permission) => {
    //                 if (permission === "granted") {
    //                     new Notification("Titolo", { body: data });
    //                 }
    //             });
    //         }


    //     } catch (error) {
    //         console.error('Error sending the push notification', error);
    //     }
    // };

    return (
        <DeviceLayoutProvider>
            <DarkModeProvider>
                <BrowserRouter>
                    <Routes>
                        <Route
                            exact
                            path="/"
                            element={<Home />}
                        />
                        <Route
                            exact
                            path="/login"
                            element={<Login />}
                        />
                        <Route
                            exact
                            path="/crea"
                            element={<Crea />}
                        />
                        <Route
                            exact
                            path="/attiva"
                            element={<Attiva />}
                        />

                        <Route
                            exact
                            path="/dev/dash"
                            element={
                                <ProtectedRoute checks={['tokenDev']}>
                                    <DashDev />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            exact
                            path="/dev/impostazioni"
                            element={
                                <ProtectedRoute checks={['tokenDev']}>
                                    <ImpostazioniDev />
                                </ProtectedRoute>
                            }
                        />

                        <Route
                            exact
                            path="/manager/dash"
                            element={
                                <ProtectedRoute checks={['tokenManager']}>
                                    <DashManager />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            exact
                            path="/manager/log"
                            element={
                                <ProtectedRoute checks={['tokenManager']}>
                                    <LogManager />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            exact
                            path="/manager/impostazioni"
                            element={
                                <ProtectedRoute checks={['tokenManager']}>
                                    <ImpostazioniManager />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            exact
                            path="/manager/clienti"
                            element={
                                <ProtectedRoute checks={['tokenManager']}>
                                    <AziendeManager />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            exact
                            path="/manager/utenti"
                            element={
                                <ProtectedRoute checks={['tokenManager']}>
                                    <UtentiManager />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            exact
                            path="/manager/categoriestati"
                            element={
                                <ProtectedRoute checks={['tokenManager']}>
                                    <CategorieStatiManager />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            exact
                            path="/manager/anagrafica"
                            element={
                                <ProtectedRoute checks={['tokenManager']}>
                                    <AnagraficaManager />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            exact
                            path="/manager/codici"
                            element={
                                <ProtectedRoute checks={['tokenManager']}>
                                    <CodiciManager />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            exact
                            path="/manager/report"
                            element={
                                <ProtectedRoute checks={['tokenManager']}>
                                    <ReportManager />
                                </ProtectedRoute>
                            }
                        />

                        <Route
                            exact
                            path="/utente/dash"
                            element={
                                <ProtectedRoute checks={['tokenUser']}>
                                    <DashUtente />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            exact
                            path="/utente/cliente"
                            element={
                                <ProtectedRoute checks={['tokenUser']}>
                                    <ClienteUtente />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            exact
                            path="/utente/articolo"
                            element={
                                <ProtectedRoute checks={['tokenUser']}>
                                    <ScanUtente />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            exact
                            path="/venditore/dash"
                            element={
                                <ProtectedRoute checks={['tokenVenditore']}>
                                    <DashVenditore />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            exact
                            path="/venditore/codici"
                            element={
                                <ProtectedRoute checks={['tokenVenditore']}>
                                    <CodiciVenditore />
                                </ProtectedRoute>
                            }
                        />
                    </Routes>
                </BrowserRouter>
            </DarkModeProvider>
        </DeviceLayoutProvider>
    );
}

export default App;
